import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Selector from "canvas-core-react/lib/Selector";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

import { loadingHtml, sucessInfoModal } from "../../../utils/functions";
import AccountTypeSelect, {
  VALUE_ACCOUNT_TYPE,
} from "../../../shared/AccountTypeSelect";
import { getAchBanks } from "../../../../Redux/reducer/providers";
import CustomInput from "./ProviderInput";
import Modal from "../../../utils/customModal";
import useApi from "../../../hooks/useApi";
import BicDestinationBankSelect from "../../../shared/BicDestinationBankSelect";

const CODE_PA = "PA";
const REGEX_VALUES = {
  STRING_AND_NUMBERS: /^[a-zA-Z0-9]+$/,
};

const ProviderNewAccount = ({ providerId, doBack, countryCode }) => {
  const [accountDetails, setAccountDetails] = useState({
    ...intDetails,
    accountNumber: "",
    accountType: VALUE_ACCOUNT_TYPE.BNS,
    accountCurrency: countryCode !== "PA" ? "CRC" : "USD",
  });

  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  // const banks = useSelector(banksState);
  const achBanks = useSelector((state) => getAchBanks(state)) || [];

  const { t } = useTranslation();
  const { postApiCAll } = useApi();

  // TODO: Ya existe una carga previa al entrar a detalles del proveedor
  // const dispatch = useDispatch();
  // const getBanks = async () => await dispatch(getACHBanks(countryCode));
  // useEffect(() => {
  //   countryCode === "PA" && getBanks();
  // }, []);

  const handleSentToApproveOrReject = (data) => {
    setLoading(true);
    return postApiCAll(`/account/${providerId}`, data, {})
      .then((response) => {
        setLoading(false);
        getModalResponse(response);
        console.log(response);
      })
      .catch((error) => {
        setLoading(false);
        getModalResponse(error.response.data);
      });
  };

  const getModalResponse = (data) => {
    let detail = "";
    let onClose = closeAndReset;

    if (data.status === 200) {
      detail = <p>Se guardó correctamente, pendiente de Aprobación.</p>;
    } else {
      detail = <p>{data.notifications[0].description}</p>;
      onClose = closeModal;
    }
    const button = { formBtn: { text: "Continuar", action: onClose } };
    const content = sucessInfoModal("Adición de Cuenta", detail, button);
    setModal({ show: true, content, onClose: onClose });
  };

  const closeAndReset = () => {
    closeModal();
    doBack();
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const handleSaveTemp = () => {
    if (
      (countryCode === CODE_PA &&
        accountDetails.accountType === VALUE_ACCOUNT_TYPE.LOCAL &&
        !accountDetails.bicDestinationBank) ||
      (accountDetails.accountType === VALUE_ACCOUNT_TYPE.INT &&
        !accountDetails.bicDestinationBank)
    ) {
      const detail = <p>Por favor ingrese BIC Banco Destino.</p>;
      const button = { formBtn: { text: "Cerrar", action: closeModal } };
      const content = sucessInfoModal("Verificar información", detail, button);
      return setModal({ show: true, content, onClose: closeModal });
    }

    if (!accountDetails.accountNumber) {
      const detail = <p>Por favor ingrese un número de cuenta.</p>;
      const button = { formBtn: { text: "Cerrar", action: closeModal } };
      const content = sucessInfoModal("Verificar información", detail, button);
      return setModal({ show: true, content, onClose: closeModal });
    }

    const data = {
      active: true,
      iban: true,
      ...(isINT
        ? accountDetails
        : {
            accountNumber: accountDetails.accountNumber,
            accountType: accountDetails.accountType,
            accountCurrency: accountDetails.accountCurrency,
            ...(accountDetails.accountType === VALUE_ACCOUNT_TYPE.LOCAL &&
              countryCode === "PA" && {
                bicDestinationBank: accountDetails.bicDestinationBank,
              }),
          }),
    };

    return handleSentToApproveOrReject(data);
  };

  const onChange = ({ target: { name, value } }) => {
    const resetDetails = name === "accountType";
    const prevState = resetDetails
      ? {
          ...accountDetails,
          ...intDetails,
          accountCurrency:
            value === VALUE_ACCOUNT_TYPE.INT
              ? "USD"
              : accountDetails.accountCurrency,
        }
      : { ...accountDetails };

    setAccountDetails({ ...prevState, [name]: value });
  };

  const isINT = accountDetails.accountType === "INT" || countryCode === "PA";

  // event: input event
  // regx: Regex for validate
  // max: max length input value
  const validateField = (event, regx, max) => {
    event?.persist();

    const { value, name } = event.target;

    if (!value) return onChange({ target: { value, name } });

    const isValidRegx = regx?.test(value);

    if (isValidRegx && value.length <= max) {
      return onChange({ target: { value, name } });
    }

    return null;
  };

  return (
    <>
      <br />
      <div>
        <div className="row">
          <div className="pl-4 input col-lg-6 col-user-provider">
            <label className="label">
              {t("general.provider_account_detail.country")}
            </label>
            <input
              className="input fix-padding input--text input-w-aux__input input--active"
              id="countryCode"
              name="countryCode"
              type="text"
              autoComplete="off"
              disabled={true}
              value={countryCode}
            />
          </div>
          <div className="input col-lg-6 col-user-provider">
            <AccountTypeSelect
              id="status"
              onChange={onChange}
              value={accountDetails.accountType}
              className="select-margin-fix"
              name="accountType"
            />
          </div>
          <div className="input col-lg-6 col-user-provider">
            <label className="label">
              {t("general.provider_account_detail.divisa")}
            </label>
            <Selector
              id="divisa"
              label=""
              className="no-label"
              name="accountCurrency"
              onChange={onChange}
              value={accountDetails.accountCurrency}
              disabled={isINT}
            >
              {countryCode !== "PA" && (
                <option key={`state-0`} value={`CRC`}>
                  CRC
                </option>
              )}
              <option key={`state-1`} value={`USD`}>
                USD
              </option>
            </Selector>
          </div>
          <CustomInput
            onChange={onChange}
            name="accountNumber"
            label="Cuenta"
            id="account"
            rowClass="input col-lg-6 col-user-provider"
            className="input fix-padding input--text input-w-aux__input input--active"
            value={accountDetails.accountNumber}
          />

          {accountDetails.accountType === "INT" && (
            <>
              <CustomInput
                onChange={onChange}
                name="bicIntermediaryBank"
                label="BIC Banco Intermedio"
                rowClass="input col-lg-6 col-user-provider"
                className="input fix-padding input--text input-w-aux__input input--active"
                value={accountDetails.bicIntermediaryBank}
              />
              <CustomInput
                name="bicDestinationBank"
                label="BIC Banco Destino"
                rowClass="input col-lg-6 col-user-provider"
                className="input fix-padding input--text input-w-aux__input input--active"
                value={accountDetails.bicDestinationBank}
                onChange={(e) =>
                  validateField(e, REGEX_VALUES.STRING_AND_NUMBERS, 11)
                }
              />
              <CustomInput
                onChange={onChange}
                name="accountIntermediaryBank"
                rowClass="input col-lg-6 col-user-provider"
                className="input fix-padding input--text input-w-aux__input input--active"
                label="Cuenta de Banco Destino con intermediario"
                value={accountDetails.accountIntermediaryBank}
              />
            </>
          )}
          {accountDetails.accountType === VALUE_ACCOUNT_TYPE.LOCAL &&
            countryCode === "PA" && (
              <div className="input col-lg-6 col-user-provider">
                <BicDestinationBankSelect
                  items={achBanks}
                  onChange={onChange}
                  id="bicDestinationBank"
                  name="bicDestinationBank"
                  value={accountDetails.bicDestinationBank}
                />
              </div>
            )}
        </div>
      </div>
      <div className="form-actions clearfix">
        <SecondaryButton id="go-back" onClick={doBack}>
          {t("general.special_codition.BACK")}
        </SecondaryButton>
        <SecondaryButton id="send-approved" onClick={handleSaveTemp}>
          Enviar Aprobación
        </SecondaryButton>
      </div>
      <Modal show={loading}>{loadingHtml()}</Modal>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  );
};

export default ProviderNewAccount;

const intDetails = {
  accountIntermediaryBank: "",
  bicDestinationBank: "",
  bicIntermediaryBank: "",
};
